import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Difference between two dates in days",
  url: "difference-between-dates-days",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
  * @param {str} date1
  * @param {str} date2
  * @return {number}
  */
      
  /**
  * Do not change this function body
  * Do your changes within the function 
  */
  
  return function diffDates(date1, date2) {
    // your code goes here        
  };
`,
};

export default info;
